import { User, UserPermissions } from "generated/graphql";
import { useCheckPermissions } from "hooks/authentication/useCheckPermissions";
import RestoreAccountMenuItem from "../RestoreAccountMenuItem/RestoreAccountMenuItem";

export default function ArchivedUserMenuItems({
  id,
  closeMenu,
}: {
  id: User["id"];
  closeMenu: () => void;
}) {
  const { hasPermissions } = useCheckPermissions();
  if (!hasPermissions(UserPermissions.MANAGE_USERS)) {
    return <></>;
  }
  return (
    <>
      <RestoreAccountMenuItem closeMenu={closeMenu} id={id} />
    </>
  );
}
